class ApiDocumenter{
  constructor(){
      this.html="";
  }
  init(log){
      this.log=log;
      if(!this.log){ return }
      this.api_version="5";
      this.link=document.createElement("a");
      this.link.id="api_doc";
      this.link.style="position:fixed;left:0;top:0;";
      this.link.innerText="download api doc";
      this.link.download="index.html"
      document.body.appendChild(this.link);




      this.html+='<html><head></head><link rel="stylesheet" href="styles.css"></head><body>'
      this.html+="<div>version:"+this.api_version+"</div>"+'\n';
  }

  add(endpoint,params,result){
      if(!this.log){ return }
      // check if endpoint already documented
      if(this.html.indexOf(endpoint)>0){
          return;
        }
  
        this.html+='<div class="call">'+'\n';
        this.html+="<h1>"+endpoint+"</h1>"+'\n';
        this.html+="<h2>parameters</h1>"+'\n';
        for(var key in params){
          this.html+='<div class="param">'+key+"["+typeof(params[key])+"]"+'</div>'+'\n';
        }
        this.html+="<h2>return value: result.data</h1>"+'\n';
        if(result.data){
          this._documentateObject(result.data)
        }
        
        // loop through data
        //this.documentateObject(data)
        this.html+="</div>"+'\n';
        


        this.link.href="data:text/plain,"+this.html+"</body></html>"
        // create a element

    }

    _documentateObject(result,indent){

      if(!indent){
        indent=0;
      }
      indent++;
      this.html+'\n';


      // if associative array...
     
      for(var key in result){
       // check if key is number
       /*
       if(isNaN(parseInt(key))){
         // key is a number and not a real key
         this.html+='<div class="object-params indent-'+indent+'">'+'\n';
          this.html+='<div class="key">'+"[array-x]"+'</div>'+'\n';
          this._documentateObject(result[key],indent);// only index first object because all sohould be same in list
          this.html+='</div>'+'\n';
          break;
         
       }else{
        // key is ok

         
       }
       */

       
       if(result[key]){
        if(result[key].length && typeof(result[key])=="object"){// found a list
          // get first
          
          this.html+='<div class="object-params indent-'+indent+'">'+'\n';
          this.html+='<div class="key">'+key+"[array]"+'</div>'+'\n';
          this._documentateObject(result[key][0],indent);// only index first object because all sohould be same in list
          this.html+='</div>'+'\n';
        }else{
          this.html+='<div class="return-param">'+key+"["+typeof(result[key])+"]"+'</div>'+'\n';
        }
      }else{
        this.html+='<div class="return-param">'+key+"["+result[key]+"]"+'</div>'+'\n';
      }
      }


      //if normal array
      if(result.length && typeof(result)=="object"){// found a list
        // get first
        
        this.html+='<div class="object-params indent-'+indent+'">'+'\n';
        this.html+='<div class="key">'+"[array]"+'</div>'+'\n';
        this._documentateObject(result[0],indent);// only index first object because all sohould be same in list
        this.html+='</div>'+'\n';
      }else{
        this.html+='<div class="return-param">'+"["+typeof(result)+"]"+'</div>'+'\n';
      }

    }




}

export let apiDocumenter = new ApiDocumenter();